module.exports = __webpack_public_path__ + "static/media/image.823b62ea.png";